export default __webpack_public_path__ + "static/media/guideMobile1.785bcf95.svg";